import { createResource, type RouteResource } from 'react-resource-router';

import { getGroupCustomizationFeatureState } from '../group-customization-state';

export const groupCustomizationFeatureStateResource: RouteResource<{
	isEnabled: boolean;
}> = createResource({
	type: 'groupCustomizationFeatureStateResource',
	getKey: () => `groupCustomizationFeatureStateResource`,
	getData: async () => {
		try {
			const response = await getGroupCustomizationFeatureState();
			return response;
		} catch {
			return {
				isEnabled: false,
			};
		}
	},
	maxAge: 5 * 60 * 1000, // 5 minutes
	isBrowserOnly: true,
});
